<template>
  <div>
    <v-app id="inspire" dark class="estilo_jep">
      <v-navigation-drawer
        clipped
        fixed
        v-model="drawer"
        app
        stateless
        hide-overlay
        v-if="$auth.hasRole('Super Administrador') || $auth.hasRole('Administrador Despacho')"
      >
        <v-list nav dense>          
          <v-list-tile to="/home/atencion_victimas">
            <v-list-tile-action>
              <v-icon>account_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Atención víctimas</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group
            no-action
            v-if="$auth.hasRole('Super Administrador') || $auth.hasRole('Administrador Despacho')"
          >
            <v-list-tile slot="activator">
              <v-list-tile-action>
                <v-icon>account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Administración</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile to="/home/users" class="linkMenu">
              <v-list-tile-action>
                <v-icon>account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Usuarios</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/home/traslado/personas/formulario" class="linkMenu">
              <v-list-tile-action>
                <v-icon>account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Personas</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/home/traslado/representantes/formulario" class="linkMenu">
              <v-list-tile-action>
                <v-icon>account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Representantes</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>

      <v-toolbar app fixed clipped-left>
        <v-img max-width="250px" src="/images/logo.png"></v-img>
        <v-toolbar-side-icon
          @click.stop="drawer = !drawer"
          v-if="$auth.hasRole('Super Administrador') || $auth.hasRole('Administrador Despacho')"
        ></v-toolbar-side-icon>
        <v-toolbar-title>{{app_name}}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
          <v-btn icon large flat slot="activator" @click="logout()" alt="Cerrar sesión">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </v-menu>
      </v-toolbar>

      <v-content>
        <v-container fluid fill-height>
          <v-layout justify-center>
            <v-flex>
              <router-view></router-view>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>

      <v-footer app fixed>
        <v-flex
          py-2
          text-xs-center
          white--text
          xs12
        >Sistema de Gestión de Abogados - JEP &copy; {{ new Date().getFullYear() }}</v-flex>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import { EventBus } from "./EventBus";
export default {
  props: ["app_name"],
  data: () => ({
    drawer: null,
    allNotifications: [],
  }),
  mounted() {},
  created() {},
  computed: {},
  methods: {
    logout() {
      axios
        .get("/logout")
        .then((response) => {
          window.location.replace("/");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="css" scoped>
.estilo_jep {
  background-color: #0b121f;
}

div.linkMenu a {
  text-decoration: none !important;
  color: white !important;
}

div.linkMenu a:hover {
  text-decoration: none !important;
  color: white !important;
}
</style>

